import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withXhr } from '@angular/common/http';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from "./auth.service";
import { InventoryErrorInterceptor } from './inventory-error.interceptor';

@NgModule({ imports: [], providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InventoryErrorInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class AuthModule
{
}
